import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Preload the hero image (LCP element) to speed up initial paint.
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/4uXSZcfaZLoWHJH1BmGxXK/CODIGO_HORMONAL_402B.jpg';
if (typeof document !== 'undefined') {
  const preload = document.createElement('link');
  preload.rel = 'preload';
  preload.as = 'image';
  preload.href = HERO_IMAGE;
  (preload as any).fetchPriority = 'high';
  document.head.appendChild(preload);
}
render(<App data-id="element-312" />, document.getElementById('root'));